import React, { Component } from "react";
import PropTypes from "prop-types";
import { Dialog, Grid } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import AttendeesTable from "./components/attendeesTable";
import AttendeesHeader from "./components/attendeesHeader";
import RegistrationSessionForm from "../../../pages/programs/addAttendance/registrationForm/registrationForm";
import { ProgramRegistrationAPI } from "../../../API/API-programRegistration";
import { ProgramsAPI } from "../../../API/API-programs";
import { EmailAPI } from "../../../API/API-Email";
import { ProgramWeekScheduleAPI } from "../../../API/API-programWeekSchedule";
import { ProgramAttendanceWithoutRegistration } from "../../../API/API-createattendeeswithoutregistration";
import Alert from "../../../materialUi/Alerts";
import DeleteParticipant from "./components/deleteParticipant";
import DefaultDialog from "../../../materialUi/defaultDialog";
import "../../../css/registrationList.css";
import { Tune } from "@material-ui/icons";

export default class RegistrationList extends Component {
  constructor(props) {
    super(props);
    const { match } = this.props;
    this.state = {
      openDialog: false,
      dialogBody: "",
      dialogTitle: "",
      buttonOne: "",
      buttonTwo: "",
      programID: match.params.programID,
      programName: "",
      numberOfSpots: 0,
      fee: 0,
      programData: "",
      weeklySchedule: null,
      selectedWeek: 0,
      openAlert: false,
      alertLocation: "",
      alertTitle: "",
      alertBody: "",
      alertStay: "",
      alertClose: "",
      openDeleteParticipant: false,
      participantData: {},
      registrationData: "",
      tableSelected: "Attendees",
      attendanceData: [],
      selectedItems: [],
      search: "",
      selectedDataForDelete: "",
      openRegistrationSession: false,
      registrationSessionStarted: false,
      status: [],
      mousePopOver: false,
      headerTotals: {
        attendees: 0,
      },
      values: {
        startDate: "",
        endDate: "",
      },
      messages: {
        startDate: "",
        endDate: "",
      },
    };
  }

  componentDidMount() {
    window.scroll({ top: 0, behavior: "smooth" });
    const { programID, headerTotals } = this.state;

    // get program information
    ProgramsAPI.GET.getProgramByID(programID)
      .then((success) => {
        if (success.data.program[0].weeklyProgram) {
          // Weekly schedule API
          ProgramWeekScheduleAPI.GET.getProgramWeekScheduleByProgramID(
            programID
          )
            .then((response) => {
              this.setState({
                weeklySchedule: response.data,
              });
            })
            .catch((error) => {
              if (error.response) {
                this.setState({
                  openAlert: true,
                  alertLocation: "/adminPortal/programs",
                  alertTitle: error.response.data.errorTitle,
                  alertBody: error.response.data.errorMessage,
                  alertClose: "CLOSE",
                  headerTotals: {},
                });
              }
            });
        }
        this.setState({
          programName: success.data.program[0].name,
          programEnrolmentEndDate: success.data.program[0].enrollmentEndDate,
          numberOfSpots: success.data.program[0].numberOfSpots,
          fee: success.data.program[0].fee,
          programData: success.data.program[0],
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          openAlert: true,
          alertLocation: "/adminPortal/programs",
          alertTitle: "Program not found!",
          alertBody: "We could not find the program. Please try again later!",
          alertClose: "CLOSE",
        });
      });

    this.loadAttendanceData();
  }

  loadAttendanceData = () => {
    const { programID } = this.state;
    ProgramAttendanceWithoutRegistration.GET.getProgramAttendanceByAttendanceID(programID)
      .then((success) => {
        const totalFamilyMembers = success.data.reduce((total, attendance) => {
          return (
            total +
            (attendance.familyMembers ? attendance.familyMembers.length : 0)
          );
        }, 0);
        this.setState({
          attendanceData: success.data,
          headerTotals: {
            attendees: totalFamilyMembers,
          },
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  resetFilters = () => {
    const { values, messages } = this.state;
    values.startDate = "";
    values.endDate = "";
    messages.startDate = "";
    messages.endDate = "";
    this.setState({ values, messages });
  };

  handleAddNewRegistrant = () => {
    sessionStorage.removeItem("exisitingAttendanceID");
    sessionStorage.removeItem("exisitingAttendanceDate");
    sessionStorage.removeItem("familyMembersInfo");

    // if (numberOfSpots < 1) {
    //   return this.setState({
    //     openAlert: true,
    //     alertLocation: `/adminPortal/programs/registrationList/${programID}`,
    //     alertTitle: 'Error',
    //     alertBody: 'There is no more spots lefts in this program.',
    //     alertClose: 'hidden',
    //     alertStay: 'CLOSE',
    //   });
    // }

    this.setState({
      openRegistrationSession: true,
      registrationSessionStarted: false,
    });
  };

  handleCloseRegistrationSession = () => {
    this.setState({
      openRegistrationSession: false,
    });
  };

  handleRegistrationSessionExited = () => {
    this.setState({
      registrationSessionStarted: false,
    });
  };

  handleDeleteParticipant = (participantObj) => {
    this.setState({
      openDeleteParticipant: true,
      selectedDataForDelete: participantObj.attendanceId
    });
   
  };

  sendWaitingListEmail = async (registrationObj) => {
    const { programName, programID } = this.state;
    registrationObj.programName = programName;
    registrationObj.programID = programID;
    await EmailAPI.EMAIL.emailWaitingList(registrationObj)
      .then((success) => {
        this.setState({
          openAlert: true,
          alertLocation: "/adminPortal/programs",
          alertTitle: "Success!",
          alertBody: `Email successfully sent to ${registrationObj.email}`,
          alertClose: "hidden",
          alertStay: "CLOSE",
        });
      })
      .catch((error) => {
        this.setState({
          openAlert: true,
          alertLocation: "/adminPortal/programs",
          alertTitle: "Server Error!",
          alertBody: " Please try again later!",
          alertClose: "hidden",
          alertStay: "CLOSE",
        });
      });
  };

  validateSpots = (registrationObj) => {
    const { membershipType } = registrationObj.membershipData;
    const {
      associateSpots,
      communitySpots,
      programID,
    } = this.state.programData;
    const requestedSpots = registrationObj.familyMembersData.length;
    let result = true;
    if (
      membershipType.toLowerCase() === "associate" &&
      associateSpots < requestedSpots
    )
      result = false;
    if (
      membershipType.toLowerCase() === "community" &&
      communitySpots < requestedSpots
    )
      result = false;
    if (!result) {
      this.setState({
        openAlert: true,
        alertLocation: `/adminPortal/programs/editProgram/${programID}`,
        alertTitle: "Cannot add attendees",
        alertBody: `  There are no ${membershipType.toLowerCase()} spots left. Please add ${requestedSpots} more ${membershipType.toLowerCase()} spots to the program`,
        alertClose: "GO TO EDIT PROGRAM",
        alertStay: "CLOSE",
      });
    }
    return result;
  };

  sendErrorMessage = (title, message) => {
    this.setState({
      openAlert: true,
      alertLocation: "/adminPortal/programs",
      alertTitle: title,
      alertBody: message,
      alertClose: "hidden",
      alertStay: "CLOSE",
    });
  };

  getMemberFee = (membershipType) => {
    const {
      programData: { communityFee, associateFee },
    } = this.state;
    const type = membershipType.toLowerCase();
    if (type === "associate") return associateFee;
    return communityFee;
  };

  checkFreeProgram = (registrationObj) => {
    const {
      programData: { variableFee, fee },
    } = this.state;
    const {
      membershipData: { membershipType },
    } = registrationObj;
    const memberFee =
      variableFee !== "yes" ? fee : this.getMemberFee(membershipType);
    if (memberFee === 0) return true;
    return false;
  };

  sendPaymentEmail = async (registrationObj) => {
    const { email, phone } = registrationObj;
    if (!email && !phone)
      return this.sendErrorMessage(
        "Error",
        "There are no contact information on the registration"
      );
    if (!email)
      return this.sendErrorMessage(
        "Error",
        `There is no email related to this registration, please contact the participant by phone ${phone}`
      );
    return await this.sendWaitingListEmail(registrationObj);
  };

  submitFreeProgram = async (registrationObj) => {
    const { programID, programData } = this.state;
    const {
      waitingListData,
      programRegistrationID,
      familyMembersData,
    } = registrationObj;
    const freePayment = true;
    registrationObj.waitingListID = waitingListData[0]._id;
    registrationObj.programID = programID;
    registrationObj.familyMembers = familyMembersData;
    registrationObj.programData = [programData];
    await ProgramRegistrationAPI.PUT.programWaitingListPayment(
      registrationObj,
      programRegistrationID,
      freePayment
    )
      .then((response) => {
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleDate = (name, value, type, requirement = "") => {
    const { values, messages } = this.state;
    values[name] = value;
    messages[name] = "";
    this.setState({ values, messages });
  };

  handleReset = () => {
    const { values, messages } = this.state;
    values.startDate = "";
    values.endDate = "";
    messages.startDate = "";
    messages.endDate = "";
    this.setState({ values, messages });
  };

  handleFreeProgram = async (registrationObj) => {
    this.setState({
      openDialog: true,
      dialogTitle: "Confirm",
      dialogBody:
        "This is a free program. Do you wish to add the participant to the program attendance list?",
      registrationObj,
    });
  };

  handleDialogActions = async (buttonName) => {
    const { registrationObj } = this.state;
    if (buttonName === "buttonOne") return this.setState({ openDialog: false });
    await this.submitFreeProgram(registrationObj);
    window.location.reload();
  };

  handleSendNotification = async (value, registrationObj) => {
    const { history } = this.props;
    const { programID } = this.state;
    const { membershipID, waitingListData } = registrationObj;
    const waitingListID = waitingListData[0]._id;

    if (!this.validateSpots(registrationObj)) return false;

    if (this.checkFreeProgram(registrationObj))
      return await this.handleFreeProgram(registrationObj);

    if (value === "Send payment email")
      return await this.sendPaymentEmail(registrationObj);

    return history.push({
      pathname: `/adminPortal/programs/waitingList/registration/${programID}/${waitingListID}/${membershipID}/0`,
      state: { from: this.props.location.pathname },
    });
  };

  getBackRoute = () => {
    const { programID } = this.state;
    const { location } = this.props;
    if (location && location.state && location.state.backToProgramDetails) {
      return `/adminPortal/programs/programDetails/${programID}`;
    }
    return "/adminPortal/programs/available";
  };

  getBackLabel = () => {
    const { location } = this.props;
    if (location && location.state && location.state.backToProgramDetails) {
      return "< Back to Program Details";
    }
    return "< Back to Programs List";
  };

  render() {
    const { history, userData } = this.props;
    const {
      programName,
      programData,
      tableSelected,
      values,
      selectedItems,
      attendanceData,
      weeklySchedule,
      selectedWeek,
      search,
      registrationData,
      status,
      openAlert,
      alertLocation,
      alertTitle,
      alertBody,
      alertStay,
      alertClose,
      messages,
      selectedDataForDelete,
      openDeleteParticipant,
      participantData,
      headerTotals,
      dialogTitle,
      dialogBody,
      openDialog,
      openRegistrationSession,
      registrationSessionStarted,
    } = this.state;
    return (
      <Grid item xs className="font-family-default">
        <DefaultDialog
          title={dialogTitle}
          body={dialogBody}
          open={openDialog}
          buttonOne="Cancel"
          buttonTwo="Confirm"
          handleChanges={this.handleDialogActions}
        />
        <Dialog
          open={openRegistrationSession}
          onClose={(event, reason) => {
            if (reason === "backdropClick") return;
            this.handleCloseRegistrationSession();
          }}
          maxWidth="md"
          fullWidth
          TransitionProps={{
            onExited: this.handleRegistrationSessionExited,
          }}
          classes={{
            paper: registrationSessionStarted
              ? "registrationSession-dialog-paper registrationSession-dialog-paper-large"
              : "registrationSession-dialog-paper",
          }}
        >
          <button
            type="button"
            className="registrationSession-close"
            onClick={this.handleCloseRegistrationSession}
          >
            <CloseIcon />
          </button>
          {!registrationSessionStarted ? (
            <div className="registrationSession-intro">
              <h2 className="registrationSession-title">Membership Registration</h2>
              <p className="registrationSession-copy">To start the registration session, please click below.</p>
              <div className="registrationSession-actions">
                <button
                  type="button"
                  className="registrationSession-primary"
                  onClick={() => this.setState({ registrationSessionStarted: true })}
                >
                  START REGISTRATION SESSION
                </button>
                <button
                  type="button"
                  className="registrationSession-secondary"
                  onClick={this.handleCloseRegistrationSession}
                >
                  CANCEL
                </button>
              </div>
            </div>
          ) : (
            <RegistrationSessionForm
              data={{}}
              userData={userData}
              programData={programData}
              registrationSession
              onCancelRegistrationSession={this.handleCloseRegistrationSession}
              onRegistrationSessionComplete={() => {
                this.handleCloseRegistrationSession();
                this.loadAttendanceData();
              }}
            />
          )}
        </Dialog>

        <AttendeesHeader
          programName={programName}
          handleChangeTable={(value) => this.setState({ tableSelected: value })}
          handleAddNewProgram={this.handleAddNewRegistrant}
          handleExport={this.handleExport}
          handleBack={() => history.push(this.getBackRoute())}
          backLabel={this.getBackLabel()}
          values={values}
          userType={userData.userData.userType}
          headerTotals={headerTotals}
          weeklySchedule={weeklySchedule}
          selectedWeek={selectedWeek}
          handleDate={this.handleDate}
          messages={messages}
          handleReset={this.resetFilters}
          resetFilters={this.resetFilters}
          handleSelectedWeek={(index) => this.setState({ selectedWeek: index })}
        />

        <AttendeesTable
          attendanceData={attendanceData}
          sortSearch={search}
          values={values}
          programName={programName}
          handleDeleteParticipant={this.handleDeleteParticipant}
          fromHistory={this.props.location && this.props.location.state && this.props.location.state.fromHistory}
        />

        <Alert
          open={openAlert}
          close={() => this.setState({ openAlert: false })}
          location={alertLocation}
          title={alertTitle}
          body={alertBody}
          stay={alertStay}
          leave={alertClose}
        />
        <DeleteParticipant
          open={openDeleteParticipant}
          close={() => {
            this.setState({ openDeleteParticipant: false });
          }}
          data={selectedDataForDelete}
        />
      </Grid>
    );
  }
}

RegistrationList.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      programID: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      backToProgramDetails: PropTypes.bool,
      fromHistory: PropTypes.bool,
    }),
  }),
  userData: PropTypes.shape({
    userType: PropTypes.string,
  }),
};

RegistrationList.defaultProps = {
  location: {},
};
